package core.dateformat.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("core.dateformat.domain")
class DateFormatUseCaseModule